<template>
  <div class="flex justify-space items-center">
    <div class="text-xl font-bold text-text leading-tight ">{{ $t('add') }}</div>
    <IconReset class="ml-auto cursor-pointer text-icon hover:text-icon-hover transition duration-200"
               @click.native="$emit('reset')"/>
  </div>
</template>

<script>
import IconReset from "@/components/icons/operationIcons/IconReset";

export default {
  name: "CreateTransactionTitle",
  components: {IconReset},
  i18n: {
    messages: {
      en: {
        add: "Create",
      },
      ru: {
        add: "Добавить",
      }
    }
  }
}
</script>